import React from "react";
import { useNavigate, Link } from "react-router-dom";
import moment from "moment-timezone";

export default function EventRow({ eventList, tabName, sendDataToParent }) {
  if (eventList === null || eventList === undefined) {
    //console.error("eventList is null or undefined");
    return;
  } else {
    //console.log("EventRow component rendered with eventList:", eventList);
  }

  const eventNewList = [];
  const sortList = [];
  let inplayCount = 0;
  let cricketCount = 0;
  let footballCount = 0;
  let tennisCount = 0;

  if (
    eventList !== null &&
    eventList !== undefined &&
    eventList.result !== undefined &&
    eventList.result.length > 0
  ) {
    let resultEventList = eventList.result;

    for (let i = 0; i < resultEventList.length; i++) {
      if (tabName === "cricket" && resultEventList[i].sports_type === 1) {
        eventNewList.push(resultEventList[i]);
        cricketCount++;
      }

      if (tabName === "football" && resultEventList[i].sports_type === 2) {
        eventNewList.push(resultEventList[i]);
        footballCount++;
      }

      if (tabName === "tennis" && resultEventList[i].sports_type === 3) {
        eventNewList.push(resultEventList[i]);
        tennisCount++;
      }

      if (
        tabName === "inplay_cricket" &&
        resultEventList[i].sports_type === 1 &&
        resultEventList[i].inplay === 1
      ) {
        eventNewList.push(resultEventList[i]);
        inplayCount++;
      }

      if (
        tabName === "inplay_football" &&
        resultEventList[i].sports_type === 2 &&
        resultEventList[i].inplay === 1
      ) {
        eventNewList.push(resultEventList[i]);
        inplayCount++;
      }

      if (
        tabName === "inplay_tennis" &&
        resultEventList[i].sports_type === 3 &&
        resultEventList[i].inplay === 1
      ) {
        eventNewList.push(resultEventList[i]);
        inplayCount++;
      }
    }
  }

  function displayTime(evt_od) {
    let mongoTime = evt_od?.$date?.$numberLong;
    let eventDate = moment(Number(mongoTime)).local().format("hh:mm A");
    return eventDate;
  }

  function displayTimeInplay(evt_od) {
    let mongoTime = evt_od?.$date?.$numberLong;
    let eventDate = moment(Number(mongoTime)).local().format("hh:mm");
    return eventDate;
  }

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const sortedByList = [...eventNewList].sort((a, b) => b.inplay - a.inplay);

  const mappedChildren = sortedByList.map((eventData) => (
    <tr style={{ background: "#e6f2fc" }}>
      {" "}
      {eventData.inplay === 1 ? (
        <td
          className="sport-date "
          style={{
            color: "white",
            backgroundColor: "#00b281",
            minWidth: "36px"
          }}
        >
          <div style={{ color: "white" }}>
            <span className="day">InPlay</span>
            <span className="market-time" style={{ fontSize: "14px" }}>
              {displayTimeInplay(eventData.evt_od)}
            </span>
            <span
              className="d-none utctime"
              data-format="H:mm"
              data-target="time"
              style={{ fontSize: "15px" }}
            >
              {displayTime(eventData.evt_od)}
            </span>
          </div>
        </td>
      ) : (
        <td className="sport-date" style={{ color: "black" }}>
          <div>
            <span className="day" style={{ fontSize: "14px" }}>
              {eventData.date}
            </span>
            <span className="market-time" style={{ fontSize: "14px" }}>
              {displayTime(eventData.evt_od)}
            </span>
            <span
              className="d-none utctime"
              data-format="H:mm"
              data-target="time"
              style={{ fontSize: "0.9em" }}
            >
              {eventData.date}{" "}
            </span>
          </div>
        </td>
      )}
      <td>
        <div className="teams">
          <strong
            className="team-1"
            style={{ fontSize: "16px", fontWeight: "bold" }}
          >
            <Link to={`/market/${eventData.cat_mid}`}>{eventData.name}</Link>{" "}
          </strong>
          <strong className="team-2">
            <a href=""></a>
          </strong>{" "}
        </div>
      </td>
      <td>
        <div className="matched">
          <span>
            {eventData.inplay === 1 ? (
              <img
                alt="BM"
                src="assets/images/tv.jpeg"
                style={{ height: "17px" }}
              />
            ) : (
              ""
            )}{" "}
            {eventData.bm === 1 ? (
              <img
                alt="BM"
                src="assets/images/DBM.svg"
                style={{ height: "17px" }}
              />
            ) : (
              ""
            )}{" "}
            {eventData.fancy == 1 ? (
              <img
                alt="BM"
                src="assets/images/fancy_1.jpeg"
                style={{ height: "17px" }}
              />
            ) : (
              ""
            )}
          </span>
          &nbsp;&nbsp;
          <span className="TMFORDESK">
            {" "}
            {formatTruncate(Math.round(eventData.totalMatched))}
          </span>
        </div>
        <span className="TMFORMOB">
          {formatTruncate(Math.round(eventData.totalMatched))}
        </span>
      </td>
      <td>
        <div className="box -blue">
          <strong style={{ fontSize: "1.25rem" }}>
            {eventData.odds.r1b != 0 ? eventData.odds.r1b : "0"}
          </strong>
          <span>{eventData.odds.rate1 != 0 ? eventData.odds.rate1 : "-"}</span>
        </div>
      </td>
      <td>
        <div className="box -pink">
          <strong style={{ fontSize: "1.25rem" }}>
            {eventData.odds.r1l != 0 ? eventData.odds.r1l : "0"}
          </strong>
          <span>{eventData.odds.rate4 != 0 ? eventData.odds.rate4 : "-"}</span>
        </div>
      </td>
      <td>
        <div
          className="box -blue m-left"
          style={{
            background: eventData.odds.r3b != 0 ? "#8dd2f0" : "#eaf6fc"
          }}
        >
          <strong style={{ fontSize: "1.25rem" }}>
            {eventData.odds.r3b != 0 ? eventData.odds.r3b : "-"}
          </strong>
          <span>
            {eventData.odds.rate13 != 0 ? eventData.odds.rate13 : "-"}
          </span>
        </div>
      </td>
      <td>
        <div
          className="box -pink m-right"
          style={{
            background: eventData.odds.r3b != 0 ? "#ffb0b3" : "#fce3e5"
          }}
        >
          <strong style={{ fontSize: "1.25rem" }}>
            {eventData.odds.r3l != 0 ? eventData.odds.r3l : "-"}
          </strong>
          <span>
            {eventData.odds.rate16 != 0 ? eventData.odds.rate16 : "-"}
          </span>
        </div>
      </td>
      <td>
        <div className="box -blue">
          <strong style={{ fontSize: "1.25rem" }}>
            {eventData.odds.r2b != 0 ? eventData.odds.r2b : "0"}
          </strong>
          <span>{eventData.odds.rate7 != 0 ? eventData.odds.rate7 : "-"}</span>
        </div>
      </td>
      <td>
        <div className="box -pink">
          <strong style={{ fontSize: "1.25rem" }}>
            {eventData.odds.r2l != 0 ? eventData.odds.r2l : "0"}
          </strong>
          <span>
            {eventData.odds.rate10 != 0 ? eventData.odds.rate10 : "-"}
          </span>
        </div>
      </td>
      <td className="action">
        <a href="javascript:void(0)">
          <i className="fa fa-info-circle"></i>
        </a>
      </td>
    </tr>
  ));
  return mappedChildren;
}